module.exports = __webpack_public_path__ + "img/money.da3ffa51.png";